import React from "react";

export default function ItemPrivacyToggle({ card, setCard }) {
  const isPrivate = Boolean(card?.is_private);
  return (
    <div className="item-privacy-row">
      <div className="item-privacy-copy">
        <strong>Keep this item private</strong>
        <span>Only you can see this item, regardless of collection privacy.</span>
      </div>
      <button
        type="button"
        className={`item-privacy-toggle${isPrivate ? " is-on" : ""}`}
        role="switch"
        aria-checked={isPrivate}
        aria-label="Keep this item private"
        onClick={() => setCard((prev) => ({ ...prev, is_private: !Boolean(prev.is_private) }))}
      >
        <span className="item-privacy-toggle-knob" />
      </button>
    </div>
  );
}
